// Three-segment progress bar at the top of the booking modal. Filled
// segments represent steps the user has reached. The component is
// stateless — the parent passes the active step number (1..3).
//
// The three logical stages collapse the underlying widget modes:
//   1 — Contact info       (lead capture)
//   2 — Choose your fitting (booking strip + confirm appointment review)
//   3 — Confirmed           (congrats)

import styles from '../styles/widget.module.css';

interface StepProgressProps {
  /** 1-indexed active step. Segments 1..step render filled; the rest empty. */
  step: 1 | 2 | 3;
}

const STEPS: Array<1 | 2 | 3> = [1, 2, 3];

export function StepProgress({ step }: StepProgressProps) {
  return (
    <div
      className={styles.stepProgress}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={3}
      aria-valuenow={step}
      aria-label={`Step ${step} of 3`}
    >
      {STEPS.map((n) => (
        <div
          key={n}
          className={`${styles.stepProgressSegment} ${
            n <= step ? styles.stepProgressSegmentActive : ''
          }`}
        />
      ))}
    </div>
  );
}
